import clsx from 'clsx';

/**
 * CategoryGrid — Paylaşılan kategori dağılım kartları
 * Gelir ve Gider Analizi sekmelerinde kullanılır.
 */
export default function CategoryGrid({ items, total, variant, formatCurrency }) {
    return (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {items.map((item, idx) => {
                const pct = total > 0 ? ((item.value / total) * 100).toFixed(1) : 0;
                return (
                    <div key={idx} className="p-4 bg-bg-tertiary rounded-xl hover:bg-bg-hover transition-colors">
                        <div className="flex items-center gap-2 mb-2">
                            <span className="text-xl">{item.icon}</span>
                            <span className="text-xs text-text-muted font-medium">{item.label}</span>
                        </div>
                        <p className="text-lg font-bold text-text-primary">{formatCurrency(item.value)}</p>
                        <div className="mt-2 flex items-center gap-2">
                            <div className="flex-1 h-1.5 bg-neutral-100 dark:bg-neutral-700 rounded-full overflow-hidden">
                                <div
                                    className={clsx(
                                        "h-full rounded-full transition-all duration-500",
                                        variant === 'income' ? 'bg-emerald-500' : 'bg-rose-500'
                                    )}
                                    style={{ width: `${pct}%` }}
                                />
                            </div>
                            <span className="text-[11px] text-text-muted font-medium w-10 text-right">%{pct}</span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
